// extracted by mini-css-extract-plugin
export var footer = "_o3-5";
export var fulfillmentInput = "_o3-0";
export var shipDateInput = "_o3-1";
export var shipmentModal = "_o3-2";
export var shipmentModalContent = "_o3-3";
export var tableContainer = "_o3-4";